import React from 'react';

export const ScheduleRow = () => {
    return (
        <div className="row thead">
            <div className="col student-col">Студент</div>
            <div className="col first-level-col">Начальный уровень</div>
            <div className="col current-level-col">Текущий уровень</div>
            <div className="col classes-attended-col align-right">Посещенные занятия</div>
            <div className="col passes-col align-right">Пропуски</div>
            <div className="col hometasks-col align-right">Домашние задания</div>
        </div>
    );
};

